import React, { useContext } from 'react';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import AppContext from '../AppContext';
import { PremiumStar } from '../shared/icons';

export const isPremium = ({ premium }) =>
  !!premium && !!premium.seconds && premium.seconds - Date.now() / 1000 > 0;

export const formatDisplayName = (displayName) => {
  if (displayName === 'Geoffrey Hale') return 'G';
  return displayName;
};

const PremiumIcon = ({ size }) => (
  <div
    style={{
      position: 'absolute',
      left: size / 48,
      top: 0,
      fontSize: size / 3,
    }}
    title="premium member supporting xbk.io"
  >
    <PremiumStar />
  </div>
);

const PresenceIcon = ({ size }) => (
  <div
    style={{
      position: 'absolute',
      right: size / 48,
      bottom: 0,
      fontSize: size / 3,
    }}
    title="online"
  >
    &#128154; {/* green heart emoji */}
  </div>
);

export const UserPhoto = ({
  size = 48,
  presence = '',
  uid,
  roundedCircle = false,
  noLink = false,
}) => {
  const { users } = useContext(AppContext);
  if (!users) {
    // console.warn('UserPhoto used before users context available');
    return null;
  }
  const user = users[uid];
  if (!user) {
    // console.warn('UserPhoto unable to find uid in global users');
    return null;
  }
  if (noLink) {
    return (
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {roundedCircle ? (
          <Image
            roundedCircle
            src={user.photoURL}
            alt="user"
            style={{ height: size, width: size }}
          ></Image>
        ) : (
          <img
            src={user.photoURL}
            alt="user"
            style={{ height: size, width: size }}
          />
        )}
        {isPremium({ premium: user.premium }) && <PremiumIcon size={size} />}
        {presence === 'online' && <PresenceIcon size={size} />}
      </div>
    );
  }
  return (
    <Link
      to={`/u/${user.uid}`}
      key={user.uid}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      {roundedCircle ? (
        <Image
          roundedCircle
          src={user.photoURL}
          alt="user"
          style={{ height: size, width: size }}
        ></Image>
      ) : (
        <img
          src={user.photoURL}
          alt="user"
          style={{ height: size, width: size }}
        />
      )}
      {isPremium({ premium: user.premium }) && <PremiumIcon size={size} />}
      {presence === 'online' && <PresenceIcon size={size} />}
    </Link>
  );
};

// TODO displayName should be gotten with uid and used by default
export const User = ({
  children = undefined,
  displayName,
  size = 24,
  uid,
  noLinkName = false,
}) => {
  if (!uid) {
    console.error('User component requires value for uid');
  }

  let content = uid; //default
  if (children) {
    content = children; //priority
  } else if (uid && displayName) {
    content = (
      <>
        <UserPhoto uid={uid} size={size} />
        <span className="ms-1">{formatDisplayName(displayName)}</span>
      </>
    );
  }

  if (noLinkName) {
    return content;
  }

  return (
    <Link to={`/u/${uid}`} style={{ whiteSpace: 'nowrap' }}>
      {content}
    </Link>
  );
};
